import { render, staticRenderFns } from "./withdrawalYX.vue?vue&type=template&id=8e2ac3a8&scoped=true&"
import script from "./withdrawalYX.vue?vue&type=script&lang=ts&"
export * from "./withdrawalYX.vue?vue&type=script&lang=ts&"
import style0 from "./withdrawalYX.vue?vue&type=style&index=0&id=8e2ac3a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2ac3a8",
  null
  
)

export default component.exports